<template>
	<div class="novedades-componente">
		<div class="novedades-div">
			<div class="col-md-5">
				<h2 class="m-2 line-height-1 text-center">
					<span>Novedades</span>
				</h2>
				<div
					id="carouselExampleFade"
					class="carousel slide carousel-fade"
					data-bs-ride="carousel"
					data-bs-config='{"pause":false}'
				>
					<div class="carousel-inner">
						<div
							v-for="(image, index) in carouselImages"
							:key="index"
							class="carousel-item"
							:class="{ active: index === 0 }"
						>
							<div class="carousel-image-container">
								<a
									@click="goTo(image.link)"
									:id="image.link"
								>
									<img
										:src="image.url"
										:alt="image.alt"
									/>
								</a>
							</div>
						</div>
						<!-- 04/09/26 -> Se pidió que se saquen las revistas de la seccion de novedades
						<div class="carousel-item revistas">
							<div class="carousel-image-container">
								<a
									@click="goTo(lastRevista)"
									:key="lastRevista"
									:id="lastRevista"
								>
									<img
										:src="`${Backend}/files/pdf/revistas/${Revista(
											lastRevista
										)}/untitled.1.png`"
										alt=""
									/>
								</a>
							</div>
						</div> 
						-->
					</div>
					<button
						class="carousel-control-prev"
						type="button"
						data-bs-target="#carouselExampleFade"
						data-bs-slide="prev"
						data-bs-pause="false"
					>
						<span
							class="carousel-control-prev-icon"
							aria-hidden="true"
						></span>
						<span class="visually-hidden">Previous</span>
					</button>
					<button
						class="carousel-control-next"
						type="button"
						data-bs-target="#carouselExampleFade"
						data-bs-slide="next"
					>
						<span
							class="carousel-control-next-icon"
							aria-hidden="true"
						></span>
						<span class="visually-hidden">Next</span>
					</button>
				</div>
			</div>
			<ul class="col-md-7 list-group">
				<div class="row-6">
					<h3 class="m-2 line-height-1 text-center">
						<span>Ultimas Noticias</span>
					</h3>
					<div v-for="(notice, index) in notices">
						<UltimasNoticiasNew
							:item="notice"
							:key="`${index}`"
						/>
					</div>
					<a href="/noticias">
						<button
							type="button"
							class="btn btn-primary"
							style="margin-top: 0.5rem"
						>
							Ver todas las noticias
						</button>
					</a>
				</div>
				<hr />
				<!-- <UltimosResultados></UltimosResultados> -->
				<div class="row-6">
					<h3 class="m-2 line-height-1 text-center">
						<span>Ultimos Resultados</span>
					</h3>
					<div v-for="(resolucion, index) in resoluciones">
						<UltimasNoticiasNew
							:item="resolucion"
							:key="`${index}`"
						/>
					</div>
					<a href="/resultados">
						<button
							type="button"
							class="btn btn-primary"
							style="margin-top: 0.5rem"
						>
							Ver todos los resultados
						</button>
					</a>
				</div>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { backend_url } from "../../../../services/ApiReq";
// import UltimasNoticias from "../UltimasNoticias/UltimasNoticias.vue";
import UltimasNoticiasNew from "../UltimasNoticias/UltimasNoticiasNew.vue";
import UltimosResultados from "../Ultimos Resultados/UltimosResultados.vue";
import { ad_url } from "../../../../services/ApiReq.js";
import axios from "axios";

export default {
	beforeMount() {
		this.ad = ad_url;
	},
	async mounted() {
		await this.$store.dispatch("getRevistas");
		await this.$store.dispatch("getUltimasNoticiasDrop");
		await this.fetchCarouselImages();
		await this.$store.dispatch("getResultados");
		await this.UltimoResultado();

		let size = 4, torneoI = 0, revistaI = 0;

		console.log( this.UltimaNoticia );

		for ( let i = 0; i < this.UltimaNoticia.length; i++ ) 
		{
			if ( (
				!this.UltimaNoticia[i].titulo.toLowerCase().includes("resultados") 
			) && torneoI <= size )
			{
				this.notices.push(this.UltimaNoticia[i])
				torneoI++
			}
			else if ( revistaI <= size )
			{
				this.resoluciones.push(this.UltimaNoticia[i])
				revistaI++
			}
		}
	},
	components: {
		UltimasNoticiasNew,
		UltimosResultados
	},
	computed: {
		...mapGetters(["revistas"]),
		...mapGetters(["isMobile"]),
		lastRevista() {
			return this.revistas.length > 0
				? this.revistas[this.revistas.length - 1]
				: null
		},
		Backend() {
			return backend_url
		},
		UltimaNoticia() {
			// return this.$store.getters.ultimas_noticias
			// 	.sort((a, b) => new Date(b.desde) - new Date(a.desde))
			// 	.slice(0, 4)
			return this.$store.getters.ultimas_noticias
				.sort((a, b) => new Date(b.desde) - new Date(a.desde))
		},
		resultados() {
			return this.results
		},
	},
	methods: {
		goTo(link) {
			if (link.startsWith("http")) {
				window.open(link, "_blank");
			} else {
				this.$router.push("revista/" + link);
			}
		},
		Revista(lastRevista) {
			return lastRevista ? lastRevista.split(".")[0] : "";
		},
		async fetchCarouselImages() {
			try {
				const response = await axios.get(
					`${process.env.VUE_APP_BACKEND_URL}/galerias/nombre/Novedades-Home`
				);

				if (
					response.data.success &&
					Array.isArray(response.data.data)
				) {
					const gallery = response.data.data[0];
					if (gallery && Array.isArray(gallery.files)) 
						this.carouselImages = gallery.files.map((file) => ({
							url: `${file.url.replace("public/", "")}`,
							alt: file.name || "Carousel image",
							link: "#",
						}))
					else {
						console.error("No files found in the gallery");
						this.carouselImages = [];
					}
				} 
				else {
					console.error(
						"Unexpected API response format:",
						response.data
					);
					this.carouselImages = [];
				}

				console.log("Fetched carousel images:", this.carouselImages);
			} 
			catch (error) {
				console.error("Error fetching carousel images:", error);
				this.carouselImages = [];
			}
		},
		async UltimoResultado() {
			try {
				const response = await fetch(
					`${process.env.VUE_APP_BACKEND_URL}/contenidos/resultados`
				)

				if ( !response.ok )
					throw new Error(
						`Error: ${response.status} ${response.statusText}`
					)
			
				let results = await response.json()

				this.results = results
			}
			catch (error) {
				console.error("Error fetching the results:", error);
				return null
			}
		},
	},
	data: () => {
		return {
			notices: [],
			resoluciones: [],
			ad: null,
			carouselImages: [],
			results: null,
		};
	},
};
</script>

<style scoped>
.novedades-componente {
	width: 100%;
}

#accordionNotices {
	padding: 0 1rem;
}

#accordionNotices h3 {
	text-align: center;
}

.layer-overlay {
	position: relative;
	display: flex;
	justify-content: center;
	gap: 0.5rem;
}

@media screen and (min-width: 200px) {
	.revistas a {
		cursor: pointer;
	}

	.redes-div {
		margin-top: 60px;
	}

	.redes-div img {
		max-width: 80px;
		text-align: center;
	}
}

@media screen and (min-width: 990px) {
	.titulo-novedades {
		margin-bottom: 30px !important;
	}

	.redes-div img {
		max-width: 80px;
		text-align: center;
	}

	.redes-div {
		margin-top: 0px;
	}

	.revistas img {
		max-width: 400px;
	}

	.h2-novedades {
		margin-bottom: 35px;
	}
}

.carousel-inner {
	width: 100%;
	padding-bottom: 133.33%; /* 3:4 aspect ratio */
	position: relative;
}

.carousel-item {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1;
}

.carousel-item::before {
	content: "";
	height: 100%;
	width: 100%;

	position: absolute;
	top: 0;
	left: 0;
	z-index: -1;

	background: white;
}

.carousel-image-container {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.carousel-image-container img {
	max-width: 100%;
	max-height: 100%;
	object-fit: contain;
}
</style>
